import { Component, OnInit } from '@angular/core';

import { AdminService } from '../../services/admin/admin.service';
import { AdminDashboardSummaryModel } from 'src/app/core/AdminDashboardSummaryModel ';

 


type DashboardTone =
  'primary' | 'secondary' | 'gold' | 'dark';


interface DashboardStat {
  label: string;
  value: number;
  description: string;
  icon: string;
  tone: DashboardTone;
}


interface DashboardCourseStat {
  label: string;
  count: number;
  lastAddedDate: string | null;
  icon: string;
  tone: DashboardTone;
  url: string;
}


interface DashboardEnquiryStat {
  label: string;
  total: number;
  approved: number;
  registered: number;
  icon: string;
  tone: DashboardTone;
}


@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {

  // Dashboard API response
  dashboard: AdminDashboardSummaryModel | null = null;

  // Dashboard loading state
  isLoading = false;

  // Dashboard error message
  errorMessage = '';

  // Overview statistics
  overviewStats: DashboardStat[] = [];

  // Course statistics
  courseStats: DashboardCourseStat[] = [];

  // Enquiry statistics
  enquiryStats: DashboardEnquiryStat[] = [];


  constructor(
    private adminService: AdminService
  ) { }


  ngOnInit(): void {

    this.loadPageData();

  }


  // =========================================================
  // LOAD DASHBOARD DATA
  // =========================================================

  loadPageData(): void {

    this.isLoading = true;
    this.errorMessage = '';

    this.adminService.getDashboard().subscribe({

      next: (summary) => {

        this.dashboard = summary;

        // =====================================================
        // OVERVIEW STATISTICS
        // =====================================================

        this.overviewStats = [



          {
            label: 'Qualification Orders',
            value: summary.qualificationOrderCount,
            description: 'Total qualification orders',
            icon: 'fa-shopping-bag',
            tone: 'gold'
          },

          {
            label: 'Short Course Orders',
            value: summary.shortCourseOrderCount,
            description: 'Total short course orders',
            icon: 'fa-credit-card',
            tone: 'dark'
          },
          {
            label: 'Customers',
            value: summary.customerCount,
            description: 'Registered customers',
            icon: 'fa-users',
            tone: 'secondary'
          }

        ];


        // =====================================================
        // COURSE STATISTICS
        // =====================================================

        this.courseStats = [

          {
            label: 'Qualifications',
            count: summary.qualificationCount,
            lastAddedDate: summary.qualificationLastSynced,
            icon: 'fa-book',
            tone: 'primary',
            url: '/admin/shortCourses'
          },
          {
            label: 'Short Courses',
            count: summary.shortCourseCount,
            lastAddedDate: summary.shortCourseLastSynced,
            icon: 'fa-book',
            tone: 'primary',
            url: '/admin/shortCourses'
          },

          {
            label: 'Skill Sets',
            count: summary.skillSetsCount,
            lastAddedDate: summary.skillSetsLastSynced,
            icon: 'fa-certificate',
            tone: 'secondary',
            url: '/admin/shortCourses'
          },

          {
            label: 'VOC Courses',
            count: summary.vocCount,
            lastAddedDate: summary.vocLastAddedDate,
            icon: 'fa-check-circle',
            tone: 'gold',
            url: '/admin/vocPublicCourses'
          }

        ];


        // =====================================================
        // ENQUIRY STATISTICS
        // =====================================================

        this.enquiryStats = [

          {
            label: 'General Enquiries',
            total: summary.generalEnquiryCount,
            approved: summary.approvedGeneralEnquiryCount,
            registered: summary.registeredGeneralEnquiryCount,
            icon: 'fa-envelope',
            tone: 'primary'
          },

          {
            label: 'Corporate Enquiries',
            total: summary.corporateEnquiryCount,
            approved: summary.approvedCorporateEnquiryCount,
            registered: summary.registeredCorporateEnquiryCount,
            icon: 'fa-building',
            tone: 'secondary'
          },

          {
            label: 'Other Course Enquiries',
            total: summary.otherCourseEnquiryCount,
            approved: summary.approvedOtherCourseEnquiryCount,
            registered: summary.registeredOtherCourseEnquiryCount,
            icon: 'fa-list-alt',
            tone: 'gold'
          }

        ];

        this.isLoading = false;

      },

      error: (error) => {

        console.error(
          'Dashboard loading error:',
          error
        );

        this.errorMessage =
          'Unable to load dashboard information. Please try again.';

        this.isLoading = false;

      }

    });

  }


  // =========================================================
  // CALCULATE PERCENTAGE
  // =========================================================

  getPercentage(value: number, total: number): number {

    if (!total || total <= 0) {
      return 0;
    }

    return Math.min(
      100,
      Math.max(
        0,
        Math.round((value / total) * 100)
      )
    );

  }

}